import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES, ENV_CONFIG, WINDOW } from '@ps/core-config';
import { UnderConstructionComponent } from '@ps/ui';

@Component({
  selector: 'ps-under-construction-page',
  standalone: true,
  imports: [UnderConstructionComponent],
  styleUrl: './under-construction.page.scss',
  template: `<ps-under-construction
    (homeRequested)="onHomeRequested()"
    (legacyRequested)="onLegacyRequested()"
  />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnderConstructionPage {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _window = inject(WINDOW);

  protected onHomeRequested(): void {
    void this._router.navigate([APP_ROUTES.ROOT]);
  }

  protected onLegacyRequested(): void {
    const path = this._activatedRoute.snapshot.data['legacyUrl'];
    const legacyUrl = `${this._env.pureSpectrum.legacyPlatformUrl}${path ?? '/dashboard'}`;
    this._window.location.href = legacyUrl;
  }
}
